import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TapIpAutomationComponent } from './tap-ip-automation/tap-ip-automation.component';
import { TapIpAutomationFileUploadComponent } from './tap-ip-automation-file-upload/tap-ip-automation-file-upload.component';
import { TapIpAutomationMisComponent } from './tap-ip-automation-mis/tap-ip-automation-mis.component';

@NgModule({
  declarations: [TapIpAutomationComponent, TapIpAutomationFileUploadComponent , TapIpAutomationMisComponent] ,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule],
  
  providers: []
})
export class AutomationModule { }
